import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
// import { SanitizeHtml } from '@bd/bdcore-utilities';
import Header from '../../components/Header';
import InsideHeader from '../../components/InsideHeader';
import MenuResources from '../../components/MenuResources';
import Footer from '../../components/Footer';
import DocumentSection from './DocumentSection';
import HOAForm from './HOAForm';

const styles = css`
  .Warranty_wrapper {
    padding: 30px 15px;
    @media(min-width: 992px) {
      padding: 90px 15px;
    }
  }
  .DocumentsList {
    padding: 0;
    list-style: none;
  }
  .DocumentList_item {
    padding: 10px 0;
    font-weight: 700;
  }
`;

const formStyles = css``;

function HOARequest({ page }) {
  return (
    <div className={styles}>
      <PageHelmet page={page} />
      <Header />
      <InsideHeader
        h1="Documents"
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuResources />
      <div className="container Warranty_wrapper">
        <div className="row">
          <div className="col-lg-5 mb-3">
            <DocumentSection page={page} />
          </div>
          <div className="col-lg-7 py-3">
            <HOAForm className={formStyles} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

HOARequest.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'warranty_request',
})(HOARequest);



// WEBPACK FOOTER //
// ./src/pages/HOARequest/index.js